import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-outstation-widgets',
  templateUrl: './outstation-widgets.component.html',
  styleUrls: ['./outstation-widgets.component.sass']
})
export class OutstationWidgetsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
